import Loader from "./components/Loader";
import { useState, useEffect, useRef } from "react";
import Vedio from "./components/Vedio";
import { client } from "./api/Client";
import "./styles/admin.css";
import Winner from "./components/Winner";
import Confetti from "react-confetti";
export default function Admin() {
  let buttonLot = useRef();
  let [load, setLoad] = useState(false);
  let [random, setRandom] = useState();
  let [linkVedios, setLinkVedios] = useState();
  let UrlRef = useRef();
  let BioRef = useRef();
  let ImgPreview = useRef();
  let UrlVedioRef = useRef();
  let UrlShowsRef = useRef();
  useEffect(() => {
    setLoad(true);
    setTimeout(() => {
      setLoad(false);
    }, 2000);
  }, []);
  const handleAddImg = () => {
    if (!UrlRef.current.value || !BioRef.current.value) {
      alert("the field is empty");
    } else {
      ImgPreview.current.src = UrlRef.current.value;
      client
        .post("/AddImages", {
          Bio: BioRef.current.value,
          ImgURL: UrlRef.current.value,
        })
        .then((res) => {
          window.location.reload();
        })
        .catch();
    }
  };
  const handleAddVedio = async () => {
    if (!UrlVedioRef.current.value) {
      alert("the field is empty");
    } else {
      setLinkVedios(UrlVedioRef.current.value);
      ImgPreview.current.src = UrlRef.current.value;
      await client
        .post("/AddVedio", {
          VedioURL: UrlVedioRef.current.value,
        })
        .then((res) => {
          window.location.reload();
        })
        .catch();
    }
  };
  const [height, setHeight] = useState(null);
  const [width, setWidth] = useState(null);
  const confetiRef = useRef(null);

  useEffect(() => {
    setHeight(confetiRef.current.clientHeight);
    setWidth(confetiRef.current.clientWidth);
  }, []);
  const handleAddShows = async () => {
    if (!UrlShowsRef) {
      alert("the field is empty");
    } else {
      setLinkVedios(UrlVedioRef.current.value);
      ImgPreview.current.src = UrlRef.current.value;
      await client
        .post("/AddShow", {
          ShowURL: UrlShowsRef.current.value,
        })
        .then((res) => {
          window.location.reload();
        })
        .catch();
    }
  };
  const handlerandom = async () => {
    await client
      .get("/random")
      .then((res) => {
        setRandom(res.data.Winner);
      })
      .catch((error) => {
        alert(error);
      });
    buttonLot.current.disabled = "true";
  };
  const handleDeleteShow = async () => {
    if (window.confirm("هل انت متأكد , تحذف عرض + ناس الى سجلت")) {
      await client
      .get("/deleteShow")
      .then((res) => {
        window.location.reload();
      })
      .catch((error) => {
        alert(error);
      });
    }
  };
  const handleDeleteImages = async () => {
    if (window.confirm("هل انت متأكد , تحذف جميع الصور")) {
      await client
      .get("/deleteImages")
      .then((res) => {
        window.location.reload();
      })
      .catch((error) => {
        alert(error);
      });
    }
  }
  const handleDeleteVedios = async () => {
    if (window.confirm("هل انت متأكد , تحذف جميع فديوهات")) {
      await client
      .get("/deleteVedios")
      .then((res) => {
        window.location.reload();
      })
      .catch((error) => {
        alert(error);
      });
    }
  }
  return (
    <>
      {load ? (
        <Loader />
      ) : (
        <div className="Admin" ref={confetiRef}>
          <section className="AddImgs">
            <h3>Add Image in works</h3>
            <div className="section">
              <lable for="bio">Bio :</lable>
              <input type="text" ref={BioRef} id="bio" />
            </div>
            <div className="section">
              <lable for="URL">URL IMG :</lable>
              <input type="url" ref={UrlRef} id="URL" />
            </div>
            <div className="submit">
              <button onClick={handleAddImg}>Submit</button>
            </div>
            <div className="submit">
              <button onClick={ handleDeleteImages }>delete Images now</button>
            </div>
            <img src="" ref={ImgPreview} className="PreviewImg" alt="Priveiw" />
          </section>
          <section className="AddImgs">
            <h3>Add Vedio in works ID</h3>
            <h6>link from Tiktok</h6>
            <div className="section">
              <lable for="URL">ID Vedio :</lable>
              <input type="url" ref={UrlVedioRef} id="URL" />
            </div>
            <div className="submit">
              <button onClick={handleAddVedio}>Submit</button>
            </div>
            <div className="submit">
              <button onClick={ handleDeleteVedios }>delete Vedios now</button>
            </div>
            <Vedio linkVedio={linkVedios} />
          </section>
          <section className="AddImgs">
            <h3>Add Shows</h3>
            <div className="section">
              <lable for="URL">URL Shows :</lable>
              <input type="url" ref={UrlShowsRef} id="URL" />
            </div>
            <div className="submit">
              <button onClick={handleAddShows}>Submit</button>
            </div>
            <hr />
            <div className="submit">
              <button onClick={ handleDeleteShow }>delete show now</button>
            </div>
          </section>
          <section className="AddImgs">
            <h3>Lots</h3>
            <div className="submit">
              <button onClick={handlerandom} ref={buttonLot}>
                Submit
              </button>
            </div>
          </section>
          {random === "undefine" ? (
            <></>
          ) : (
            random?.map((item) => {
              return (
                <>
                  <Winner key={item._id} Massage={item.Name} Tel={item.Tel} />
                  <Confetti
                    numberOfPieces={150}
                    width={width}
                    height={height}
                  />
                </>
              );
            })
          )}
        </div>
      )}
    </>
  );
}
